export default "__VITE_ASSET__D696Cg34__"